var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingCheck)?_c('div',[_c('div',{staticClass:"loading-container",style:(_vm.areaStyle)},[_c('v-progress-circular',{attrs:{"size":50,"color":"white","indeterminate":""}}),_c('h4',[_vm._v(_vm._s(_vm.loadingMessage))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }